import React from "react";
import { useSelector } from "react-redux";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import { BillItemContainer, } from "./styles";

const CurrentRoom = () => {

  const currentRoom = useSelector(state => state.selectReducer.currentRoom)

  return (
    <Card
      className='currentRoom'
      additionalstyle={`
        width: 100%;
        max-width: 379px;
        height: 100%;
        margin: 24px 15px;
      `}      
    >
      <CardHeader>
        <div className="cardTitle">Current Room</div>
      </CardHeader>
      <BillItemContainer>
        <div className='roomType'>
          <span className="description">Room Type</span>
          <span className="value">{currentRoom?.roomType?.name + (currentRoom?.barrierFree? ' (Barrier Free)': '')}</span>
        </div>
        <div className='roomNumber'>
          <span className="description">Room Number</span>
          <span className="value">{currentRoom?.roomNumber}</span>
        </div>
        <div className='nightlyPrice'>
          <span className="description">Nightly Price</span>
          <span className="value">{currentRoom?.pricePerNight.toFixed(2) || 'N/A'}</span>
        </div>
      </BillItemContainer>
    </Card>
  )
}

export default CurrentRoom;
